import { render, staticRenderFns } from "./MyLearningGoalInfo.vue?vue&type=template&id=e057f978&scoped=true&"
import script from "./MyLearningGoalInfo.vue?vue&type=script&lang=js&"
export * from "./MyLearningGoalInfo.vue?vue&type=script&lang=js&"
import style0 from "./MyLearningGoalInfo.vue?vue&type=style&index=0&id=e057f978&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e057f978",
  null
  
)

export default component.exports